export { patientProfileRelations } from './patientProfileRelations';
export { consultationRelations } from './consultationRelations';
export { patientPaymentMethodRelations } from './patientPaymentMethodRelations';
